import { render, staticRenderFns } from "./Accountnav.vue?vue&type=template&id=48851552&"
import script from "./Accountnav.vue?vue&type=script&lang=js&"
export * from "./Accountnav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports